import Imgs from "./Imgs";

export default Imgs;